export default [
    {
        name: '__slot:url',
        sortField: 'url',
        type: 'string',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: 'it1',
        sortField: 'it1',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'it3',
        sortField: 'it3',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'it5',
        sortField: 'it5',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'it10',
        sortField: 'it10',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'it50',
        sortField: 'it50',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true
    },
    {
        name: 'vis',
        sortField: 'vis',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: 'pos',
        sortField: 'pos',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'frequency',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'adscnt',
        sortField: 'adscnt',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'docs',
        sortField: 'docs',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'mincpc',
        sortField: 'cpc_min',
        type: 'float',
        callback: 'float',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'maxcpc',
        sortField: 'cpc_max',
        type: 'float',
        callback: 'float',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'isgeo',
        type: 'bool',
        defaultSearch: false,
        useInFilter: true,
        visible: false,
    },
    {
        name: 'isquest',
        type: 'bool',
        defaultSearch: false,
        useInFilter: true,
        visible: false,
    },
    {
        name: '__slot:keys_meta',
        dataClass: 'text-center',
        defaultSearch: false,
        useInFilter: false,
    },


]
